import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';


function RestaurantItem(props) {
    const {item, index, onEdit} = props;

    const [ url ] = useState( props.item.mediaUrl );

    useEffect(() => {
    }, []);

    const onClick = () => {
        onEdit(item);
    }

    return (
        <div id={'restaurant-item'} key={'restaurant-item-' + index} className={'restaurant-item'} onClick={onClick}>
            <h3 className="code">{item.showOrder + ' - ' +  (item?.title || '')}</h3>
            <img className={'image' + (!item?.status ? ' grayscale' : '')}
                 src={url}
                 alt={item?.title}
            />
        </div>
    );
}

RestaurantItem.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

export default RestaurantItem;